import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { NotificationSettings, NotificationSettingsPayload } from '@/types/notifications';
import { BaseApiResponse } from '@/types/api/api-v2';
export default async function doUpdateNotificationsSettings(payload: NotificationSettingsPayload) {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.patch<BaseApiResponse<NotificationSettings>>(
      '/notifications/settings',
      payload
    );
    return data;
  } catch (error) {
    throw error;
  }
}
